import { HTTP } from './common'

export const UserApi = {

  check_activate(code){
    return HTTP.post('/auth/check_activation/', {code: code})
  },

  restore_password(email){
    return HTTP.post('/auth/restore_password/', {email: email})
  },

  check_token(uid, token){
    return HTTP.post('/auth/check_token/', {uid: uid, token: token})
  },

  change_password(data){
    return HTTP.post('/auth/change_password/', data)
  },


  get_settings(){
    return HTTP.get('/users/get_settings/').then(response => {
      return response.data
    });
  },

  update_password(data){
    return HTTP.post('/users/update_password/', data).then(response => {
      return response.data
    });
  },
  update_user(data){
    return HTTP.post('/users/update_user/', data)
  },

  feedback(data){
    return HTTP.post('/users/feedback/', data)
  },

  get_code(){
    return HTTP.get('/users/get_tg_secret_code/').then(response => {
      return response.data
    });
  },


};


